import { Code, Group, Stack, Text, Tooltip } from "@mantine/core";
import { IconFilePlus, IconWand } from "@tabler/icons-react";

import { WhatsNewUpdate } from "../update";

export const update20240102: WhatsNewUpdate = {
  id: "3F51D57C-BD7C-4A9D-A2BD-A7D35B9AFD71",
  date: "2024-01-02",
  subject: (
    <Group spacing="xs">
      One-column layout, hotkeys, and a wizard
      <IconWand />
    </Group>
  ),
  content: (
    <Stack>
      <Text>
        This change brings a brand new, streamlined way to start a fresh document. Now when you
        click the{" "}
        <Tooltip label="New checklist document...">
          <IconFilePlus size={16} />
        </Tooltip>{" "}
        icon in the editor you'll be greeted with the option to either start a new blank document or
        compose a new checklist from existing addon templates. If you choose the latter, you can
        select a base aircraft to start from and then add one or more software addons. This is a
        great way to kickstart a complex sim setup that relies on lots of addons.
      </Text>
      <Text>
        This release also contains hotkey support for undo/redo (<Code>ctrl/cmd-Z</Code>,{" "}
        <Code>ctrl/cmd-Y</Code>) and adds a new one-column layout option.
      </Text>
    </Stack>
  ),
};
